import React from 'react'

interface Props {
  size?: number
  color?: string
  className?: string
}

// icon_chat_inspiration_collapse_light - 收起图标
const ChatInspirationCollapseLightIcon: React.FC<Props> = ({
  size = 16,
  color = 'white',
  className = '',
}) => {
  return (
    <div style={{ width: size, height: size }} className={className}>
      <svg width={size} height={size} viewBox="0 0 16 16" fill="none">
        <path
          d="M5.89463 9.47417C6.24346 9.47417 6.52583 9.75654 6.52583 10.1054V15.3688C6.52583 15.7176 6.24346 16 5.89463 16C5.5458 16 5.26343 15.7176 5.26343 15.3688V11.6289L1.07736 15.815C0.830698 16.0616 0.431702 16.0616 0.185042 15.815C-0.0616172 15.5683 -0.0616172 15.1693 0.185042 14.9226L4.37111 10.7366H0.6312C0.282371 10.7366 0 10.4542 0 10.1054C0 9.75654 0.282371 9.47417 0.6312 9.47417H5.89463ZM14.9226 0.185042C15.1693 -0.0616172 15.5683 -0.0616172 15.815 0.185042C16.0616 0.431702 16.0616 0.830698 15.815 1.07736L11.6289 5.26343H15.3688C15.7176 5.26343 16 5.5458 16 5.89463C16 6.24346 15.7176 6.52583 15.3688 6.52583H10.1054C9.75654 6.52583 9.47417 6.24346 9.47417 5.89463V0.6312C9.47417 0.282371 9.75654 0 10.1054 0C10.4542 0 10.7366 0.282371 10.7366 0.6312V4.37111L14.9226 0.185042Z"
          fill={color}
        />
      </svg>
    </div>
  )
}

export default ChatInspirationCollapseLightIcon
